module.exports = __webpack_public_path__ + "static/media/zabg.4f38db7b.gif";